module.exports = __webpack_public_path__ + "img/logobanner.1f7d8003.png";